export const notificationModules = {

  whatsapp: {

    label: "WhatsApp",

    color: "#22c55e",

    background: "rgba(34,197,94,.12)",

    icon: "💬"

  },

  citas: {

    label: "Calendario",

    color: "#2563eb",

    background: "rgba(37,99,235,.12)",

    icon: "📅"

  },

  finanzas: {

    label: "Finanzas",

    color: "#f59e0b",

    background: "rgba(245,158,11,.12)",

    icon: "💰"

  },

  inventario: {

    label: "Inventario",

    color: "#ea580c",

    background: "rgba(234,88,12,.12)",

    icon: "📦"

  },

  ia: {

    label: "IA",

    color: "#9333ea",

    background: "rgba(147,51,234,.12)",

    icon: "🤖"

  },

  system: {

    label: "Sistema",

    color: "#64748b",

    background: "rgba(100,116,139,.12)",

    icon: "🦷"

  }

};